;(function($){
	
	(function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
	;r.type="text/javascript";r.async=true
	;r.src="https://cdn.amplitude.com/libs/amplitude-4.4.0-min.gz.js"
	;r.onload=function(){if(e.amplitude.runQueuedFunctions){
	e.amplitude.runQueuedFunctions()}else{
	console.log("[Amplitude] Error: could not load SDK")}}
	;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
	;function s(e,t){e.prototype[t]=function(){
	this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
	var o=function(){this._q=[];return this}
	;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
	;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
	;return this}
	;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
	;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
	;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
	;function v(e){function t(t){e[t]=function(){
	e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
	for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
	e=(!e||e.length===0?"$default_instance":e).toLowerCase()
	;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
	;e.amplitude=n})(window,document);

	amplitude.getInstance().init("37b4b2d240ee6320ca68038597f1ce70");
	
	
	var pcGsAmplitude = function(){ 
		var cls = this; 

		cls.call = function(eventName, param){
		  	var user_id = cls.getCookie("wa_catvid");
		    var user_gd = cls.getCookie("gd");
		    var user_yd = cls.getCookie("yd");
		     
		    if(null == user_id){
		    	user_id = 0;
		    }
		    if(null == user_gd){
		    	user_gd = 0;
		    }
		    if(null == user_yd){
		    	user_yd = 0;
		    }      
		       
		    try{
		      
		    	  setTimeout(function () {
		    		  if(user_id != null && user_id != 0){
		    			  amplitude.getInstance().setUserId(user_id);
		    		  }
		    		  
		    		  var identify = new amplitude.Identify().set('gd', user_gd).set('yd', user_yd);
		    		  amplitude.getInstance().identify(identify);
		    		  
		    		  if( param ){
		    			  amplitude.getInstance().logEvent(eventName, param);
		    		  }else{
		    			  amplitude.getInstance().logEvent(eventName);
		    		  }
		    	  }, 2000);
		    	  
		    }catch(exception){
		      console.log('amp Fail');
		    }  
			
		}
		cls.getCookie = function(name){
			var arg = name + "=";
			var alen = arg.length;
			var clen = document.cookie.length;
			var i = 0;
			while(i < clen){
			  	var j = i + alen;
			  	if(document.cookie.substring(i, j) == arg) 
			  		return cls.getCookieVal(j);
			  	i = document.cookie.indexOf(" ", i) + 1;
			  	if(i == 0) 
			  		break;
			}
			return null;
		}
		cls.getCookieVal = function(offset){
		    var endstr = document.cookie.indexOf(";", offset);
		    if(endstr == -1)
		        endstr = document.cookie.length;
		    return decodeURIComponent(document.cookie.substring(offset, endstr));
		}
		
		return cls;
	}

	window.pcGsAmplitude = window.pcGsAmplitude || new pcGsAmplitude(); 

})(jQuery);
